
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuC4oOC4ueC4oeC4tOC4oOC4suC4hCJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuC4oOC4ueC4oeC4tOC4oOC4suC4hCJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6Ikxva2FzaSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6Ikxva2FzaSJ9!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuWcsOm7niJ9!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuWcsOm7niJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IkxvY2F0aW9uIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuC4oOC4ueC4oeC4tOC4oOC4suC4hCJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuC4oOC4ueC4oeC4tOC4oOC4suC4hCJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6Ikxva2FzaSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6Ikxva2FzaSJ9!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuWcsOm7niJ9!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IuWcsOm7niJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IlvFgcO2w7bDp8SDxIPhua%2FDrMOsw7bDtuC4geC4teC5iV0ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../virtual-resource-loader@2.0.1/node_modules/virtual-resource-loader/dist/index.js?source=eyJMb2NhdGlvbiI6IlvFgcO2w7bDp8SDxIPhua%2FDrMOsw7bDtuC4geC4teC5iV0ifQ%3D%3D!"
        )
      )
      });
  
      export { translations as translations };
    